import { createContext, useContext } from 'react'

export interface TLocalisationFlowsExperiment {
  isNewLocalisedFlow: boolean
}
export const LocalisationFlowsExperimentContext = createContext<TLocalisationFlowsExperiment>({
  isNewLocalisedFlow: false,
})

export const useLocalisationFlowsExperimentContext = (): TLocalisationFlowsExperiment => {
  return useContext(LocalisationFlowsExperimentContext)
}
